import Enum from "../../../enums/Enum";

const EnumBreakTimeAM = new Enum({
    NO_BREAK: "No Break",
    MID_MORNING: "Mid-Morning",
    BEFORE_LUNCH_BREAK: "Before Lunch Break"
});

export default EnumBreakTimeAM;
